import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import InputBoxOnChange from 'src/components/inputbox/InputBoxOnChange';
import { getUser } from 'src/api/User';
import { UserType } from 'src/types/UserType';
import { ActionButton, NextButton, NextButtonWrapper } from 'src/components/common/CommonStyled';
import { useUserInfoStore } from 'src/stores/UserInfoStore';
import { ExclusionType } from 'src/types/SchoolType';
import Excluded from 'src/components/myInfo/Excluded';
import ManageRegion from 'src/components/common/ManageRegion';
import { RegionsType } from 'src/types/SchoolType';
import RegionSelectorMyInfo from 'src/components/myInfo/RegionSelectorMyInfo';
import ChangePassword from 'src/components/myInfo/ChangePassword';
import InputBoxOnChangeValid from 'src/components/myInfo/InputBoxOnChangeValid';
import InputBoxOnBlurChildren from 'src/components/inputbox/InputBoxOnBlurChildren';
import CountdownTimer from 'src/utils/CountdownTimer';
import { postAuthEmail } from 'src/api/User';
import { AlertSpan } from 'src/components/common/CommonStyled';
import { ButtonSubmit } from 'src/components/myInfo/ButtonSubmit';
import { useModalStore } from 'src/stores/ModalStore';
import { ModalContentDelete, ModalFooterDelete, ModalTitleDelete } from 'src/components/myInfo/ModalFieldMyinfo';

// Styled components for the page layout
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  max-height: calc(100vh - 136px);
  overflow-y: auto;
`;

const InputContainer = styled.div`
  width: 100%;
  max-width: 600px;
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 45px;
`;

const Label = styled(Typography)({
  color: '#7F7F89',
  fontSize: '14px',
  paddingBottom: '10px'
})

const FormInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
  height: 46px;
`;
const DeleteButton = styled.button`
  all: unset;
  font-size: 14px;
  color: #7F7F89;
  text-decoration: underline;
`
const MyInfo = () => {
  const [userInfo, setUserInfo] = useState<Partial<UserType>>({});
  const modalSetField = useModalStore((state)=>state.setField)
  const reset = useUserInfoStore((state)=>state.reset)
  const [isModify,setIsModify] = useState(true)
  const [refresher,setRefresher] = useState(true)
  const [isChangePW,setIsChangePW] = useState(false)
  const [tempRegion,setTempRegion] = useState<RegionsType>({});
  const [tempExcludedInfo,setTempExcludedInfo] = useState<ExclusionType[]>([])

  const [isChangeEmail,setIsChangeEmail] = useState(false)
  const [authCode,setAuthCode] = useState('')
  const [inputAuthCode,setInputAuthCode] = useState('')
  const [authCodeVerify,setAuthCodeVerify] = useState(true)
  const [authCodeValid,setAuthCodeValid] = useState(true)
  const [isTimeout,setIsTimeout] = useState(false)
  const [resetTimer,setResetTimer] = useState(0)
  const [isEmailVerify,setIsEmailVerify] = useState(true)
  const [isEmailVaild,setIsEmailVaild] = useState(true)

  // const [armyNumber,setArmyNumber] = useState('')
  const [name,setName] = useState('')
  const [phone,setPhone] = useState('')
  const [email,setEmail] = useState('')

  //발리데이션
  // const [cond0,setCond0] = useState(false)
  const [cond1,setCond1] = useState(false)
  const [cond2,setCond2] = useState(false)
  const [cond3,setCond3] = useState(false)
  const isValid = useMemo(()=>{
    const isTempRegionValid = !tempRegion || Object.keys(tempRegion).length === 0;
      return cond1 && cond2 && cond3 && isEmailVerify && !isTempRegionValid
  },[cond1,cond2,cond3,isEmailVerify,tempRegion])

  // 최초 1회 데이터 로딩
  useEffect(() => {
    const fetchData = async () => {
      const userdata = await getUser();
      setUserInfo({
        user_id: userdata.data.user_id,
        phone: userdata.data.phone,
        uid: userdata.data.uid,
        user_name: userdata.data.user_name,
        user_type: userdata.data.user_type,
        email: userdata.data.email,
        // army_number: userdata.data.army_number,
        user_area: userdata.data.user_area,
        excluded_highschool: userdata.data.excluded_highschool,
        excluded_university: userdata.data.excluded_university,
        team_name: userdata.data.team_name ?? '소속 없음'
      });
    };
    fetchData();
  }, []);

  useEffect(()=>{
    if (userInfo) {
    setTempRegion(userInfo.user_area ?? {})
    // setArmyNumber(userInfo.army_number ?? '')
    setName(userInfo.user_name ?? '')
    setPhone(userInfo.phone ?? '')
    setEmail(userInfo.email ?? '')
    }
  },[userInfo])

  const handleSubmit = (e:React.FormEvent)=>{
    e.preventDefault();
  }

  const handleCancle = ()=>{
    setTempExcludedInfo([])   // ❗숨김 해제 → 다시 보여짐
    setAuthCode('')
    setAuthCodeValid(true)
    setIsChangeEmail(false)
    setIsEmailVerify(true)
    reset()
    setIsModify(true)
    setRefresher(false)
    setTempRegion(userInfo.user_area ?? {})
    // setArmyNumber(userInfo.army_number ?? '')
    setName(userInfo.user_name ?? '')
    setPhone(userInfo.phone ?? '')
    setEmail(userInfo.email ?? '')
    setTimeout(()=>setRefresher(true),0)
  }

  const handleAuthEmail = async (user_email:string) => {

    const response = await postAuthEmail(user_email)
    if(response.status === false){
        setIsEmailVaild(false)
        setAuthCode('')
        setIsEmailVerify(false)
        return
    }
    setAuthCodeVerify(false);
    setAuthCode(response.code.slice(2));

    // 🔥 타이머 리셋!
    setResetTimer((prev) => prev + 1)
    setIsTimeout(false)
  }

  const handleEmailVerify = ()=>{
    if(!authCode) return
    if(inputAuthCode === authCode) {
      setIsEmailVerify(true)
      setAuthCodeValid(true)
      setIsChangeEmail(false)
    }
    else{
      setIsEmailVerify(false)
      setAuthCodeValid(false)
    }
    setAuthCodeVerify(true)
  }

  // const handleArmyNumber = (e:React.ChangeEvent<HTMLInputElement>)=>{
  //   setArmyNumber(e.target.value)
  // }

  const handleName = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setName(e.target.value)
  }

  const handlePhone = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setPhone(e.target.value)
  }

  const handleEmail = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setIsEmailVaild(true)
    setEmail(e.target.value)
  }

  const onClickDeleteAccount = ()=>{
    modalSetField('type','CENTER')
    modalSetField('padding','24px')
    modalSetField('width','calc(100vw - 40px)')
    modalSetField('title',ModalTitleDelete)
    modalSetField('content',ModalContentDelete)
    modalSetField('footer',<ModalFooterDelete/>)
    modalSetField('open',true)
  }
  return (
    <>
    {refresher && 
      (isChangePW ? 
      <ChangePassword setChangePW={setIsChangePW}/>
      :
      <Container>
        <form onSubmit={handleSubmit} style={{display:'flex', flexDirection:'column', gap:'20px'}}>
        <InputContainer>
          <Label>아이디</Label>
          <InputBoxOnChange placeholder={userInfo.user_id ?? ''} disabled={true}/>
        </InputContainer>
        <InputContainer>
          <Label>비밀번호</Label>
          <FlexRow>
          <InputBoxOnChange value={'**********'} disabled={true}/>
            <ActionButton onClick={()=>setIsChangePW(true)}>
              비밀번호 변경
            </ActionButton>
          </FlexRow>
        </InputContainer>
        {/* <InputContainer>
          <Label>군번</Label>
          <InputBoxOnChangeValid 
          disabled={isModify} 
          value={armyNumber}
          onChange={handleArmyNumber}
          lengthRegex={/^.{1,11}$/} lengthSpan='군번은 최대 11자까지 가능합니다'
          regex0={/^[0-9-]+$/} regex0Span="숫자와 '-'만 사용 가능합니다"
          setCond={setCond0}/>
        </InputContainer> */}
        <InputContainer>
          <Label>이름</Label>
          <InputBoxOnChangeValid 
          disabled={isModify} 
          value={name}
          onChange={handleName}
          lengthRegex={/^.{2,5}$/} lengthSpan='이름은 2~5자만 가능합니다.'
          regex0={/^[가-힣]+$/} regex0Span="한글만 입력 가능합니다."
          setCond={setCond1}/>
        </InputContainer>
        <InputContainer>
          <Label>연락처</Label>
          <InputBoxOnChangeValid 
          disabled={isModify} 
          value={phone}
          onChange={handlePhone}
          lengthRegex={/^.{10,11}$/} lengthSpan='전화번호는 10~11자여야합니다.'
          regex0={/^[0-9]+$/} regex0Span="숫자만 입력 가능합니다."
          setCond={setCond2}/>
        </InputContainer>
        <InputContainer>
          <Label>이메일</Label>
          <FormInputContainer>
          <InputBoxOnChangeValid 
          disabled={!isChangeEmail} 
          value={email}
          onChange={handleEmail}
          lengthRegex={/^.{0,50}$/} lengthSpan='이메일은 최대 50자까지 가능합니다.'
          regex0={/^[A-Za-z][A-Za-z0-9._%+-]*[A-Za-z0-9]@[A-Za-z0-9.-]+\.[A-Za-z]+$/} regex0Span="이메일 형식에 맞지 않습니다."
          setCond={setCond3}/>
            {!isModify && (
              isChangeEmail ? 
                (authCode ? 
                  <ActionButton disabled={!isTimeout || isEmailVerify || !cond3}onClick={()=>handleAuthEmail(email!)}>
                    재전송
                  </ActionButton> 
                  :
                  <ActionButton disabled={!cond3} onClick={() => handleAuthEmail(email!)}>
                    인증코드 전송
                  </ActionButton>
              ) : (
                <ActionButton onClick={() => {
                  setIsChangeEmail(true)
                  setIsEmailVerify(false)
                  }}>
                  변경
                </ActionButton>
              )
            )}
          </FormInputContainer>
          {!isEmailVaild && <AlertSpan $isValid={false}>이미 등록된 이메일입니다.</AlertSpan>}
          {(authCode.length !==0 && isChangeEmail) && 
          <FormInputContainer style={{marginTop:"5px"}}>
              <InputBoxOnBlurChildren
                type='text'
                placeholder="인증번호"
                defaultValue=''
                onBlur={(e)=>setInputAuthCode(e.target.value)}
                children={
                  (!authCodeVerify || !authCodeValid) && <CountdownTimer m={5} resetTrigger={resetTimer} setState={setIsTimeout}/>
                }
                disabled={isEmailVerify}
              />
            <ActionButton disabled={isEmailVerify || isTimeout} style={{ padding: '13px 31px' }}onClick={()=>handleEmailVerify()}>
              인증
            </ActionButton>
          </FormInputContainer>}
          {isChangeEmail && (!authCodeValid && <AlertSpan $isValid={false}>인증번호가 일치하지 않습니다.</AlertSpan>)}
        </InputContainer>
        <InputContainer>
          <Label>소속팀</Label>
          <InputBoxOnChangeValid 
          disabled={true} 
          value={userInfo.team_name}
          // onChange={handleArmyNumber}
          // lengthRegex={/^.{1,11}$/} lengthSpan='군번은 최대 11자까지 가능합니다'
          // regex0={/^[0-9-]+$/} regex0Span="숫자와 '-'만 사용 가능합니다"
          // setCond={setCond0}
          />
        </InputContainer>
        <InputContainer>
        <Label>담당지역</Label>
          {isModify ? <ManageRegion user_area={userInfo.user_area} isModify={true}/>:
          <RegionSelectorMyInfo user_area={userInfo.user_area} setRegion={setTempRegion}/>}
          {(!tempRegion || Object.keys(tempRegion).length === 0) && <AlertSpan $isValid={false}>담당 지역을 1개 이상 설정해주세요</AlertSpan>}
        </InputContainer>
        <InputContainer>
        <Label>홍보 대상 제외 학교</Label>
          <Excluded highschoolInfo={userInfo.excluded_highschool} universityInfo={userInfo.excluded_university} isModify={isModify} 
          setTempExcludedInfo={setTempExcludedInfo}/>
        </InputContainer>
        {isModify ? 
        <DeleteButton onClick={onClickDeleteAccount}>계정탈퇴</DeleteButton>
        :
        <></>
        }
        </form>
      </Container>)}
      {!isChangePW && 
        (isModify ? 
        <NextButtonWrapper style={{ display:'flex', gap:'10px'}} $isBorder={true}>
          <NextButton onClick={()=>setIsModify(false)}>수정</NextButton>
        </NextButtonWrapper>
        :
        <NextButtonWrapper style={{ display:'flex', gap:'10px'}} $isBorder={true}>
          {/* 리렌더를 통해 inputBox값 초기화 */}
          <>
          <NextButton style={{background:'#F5F5F5', color:'#7F7F89', width:'90px'}} onClick={handleCancle}>취소</NextButton>
          <ButtonSubmit disabled={!isValid} area={tempRegion} email={email!} phone={phone!} name={name!}
          include_arr={tempExcludedInfo}/>
          </>
        </NextButtonWrapper> 
        )
      }
    </>
  );
};

export default MyInfo;